import React from 'react';
import { CategoryTabs } from '../navigation/CategoryTabs';
import { LeftSidebar } from '../sidebar/LeftSidebar';
import { CenterPreview } from '../preview/CenterPreview';
import { RightPaymentPanel } from '../panel/RightPaymentPanel';

export const SinglePageLayout: React.FC = () => {
    return (
        <div className="flex flex-col min-h-screen h-auto bg-gray-100 overflow-y-auto lg:h-screen lg:overflow-hidden">
            <CategoryTabs />
            <div className="flex flex-col lg:flex-row flex-1 lg:overflow-hidden relative h-auto lg:h-full">
                {/* Mobile Order: Preview (Top) -> Sidebar (Middle) -> Payment (Bottom) */}

                {/* Center Preview - Mobile: Top, Desktop: Center (Order 2) */}
                <div className="order-1 lg:order-2 w-full h-[60vh] lg:h-full lg:flex-1 relative z-10 shrink-0">
                    <CenterPreview />
                </div>

                {/* Left Sidebar - Mobile: Middle, Desktop: Left (Order 1) */}
                <div className="order-2 lg:order-1 w-full lg:w-auto h-auto lg:h-full lg:overflow-hidden z-20 shrink-0">
                    <LeftSidebar />
                </div>

                {/* Right Payment Panel - Mobile: Bottom, Desktop: Right (Order 3) */}
                <div className="order-3 lg:order-3 w-full lg:w-auto h-auto lg:h-full z-30 shrink-0">
                    <RightPaymentPanel />
                </div>
            </div>
        </div>
    );
};
